import React, { Component } from "react";
import ApiRequest from "../libs/request.js";
import Recaptcha from "./shared/Recaptcha";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
//import AppleLogin from 'react-apple-login'
import GoogleLogin from "react-google-login";
// import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

class Login extends Component {
  constructor(props) {
    super(props);
    this.email = React.createRef();
    this.password = React.createRef();
    this.errorsPanel = React.createRef();
    this.recaptcha = React.createRef();
    this.responseGoogle = this.responseGoogle.bind(this);
    this.handleRecaptchaChange = this.handleRecaptchaChange.bind(this);
    this.state = {
      errors: [],
      isLoading: false,
      recaptchaToken: null
    };
  }

  handleRecaptchaChange(token) {
    this.setState({ recaptchaToken: token });
  }

  resetRecaptcha() {
    if (this.recaptcha.current) {
      this.recaptcha.current.reset();
    }
  }

  responseGoogle(response) {
    if (!this.state.recaptchaToken) {
      toast.error("Please verify that you are not a robot");
      return;
    }
    if (response.profileObj) {
      var profile = response.profileObj;
      let params = {
        email: profile.email,
        provider_id: profile.googleId,
        provider_name: "google",
        recaptcha_token: this.state.recaptchaToken,
      };
      this.setState({ isLoading: true });
      let apiRequest = new ApiRequest("post", "/user/social-login");
      apiRequest.send(params, (response) => {
        let result = response.data;

        if (result.message === "Signup Successful.") {
          toast.info("Signup Successful. Please login now.");
          this.setState({ isLoading: false });
          return;
        }

        if (result.errors) {
          this.setState({ isLoading: false });
          toast.error(result.message || "Login failed");
        } else {
          localStorage.setItem("gorilla-token", result.token);
          localStorage.setItem("current_user", JSON.stringify(result.user));
          toast.success("Login successful!");
          setTimeout(() => {
            location.href = "/";
          }, 500);
        }
      });
    } else {
      toast.error("Google authentication failed");
    }
  }

  responseFacebook(response) {
    if (response.email) {
      var profile = response;
      let params = {
        email: profile.email,
        social_id: profile.id,
        first_name: profile.name.split(" ")[0],
        last_name: profile.name.split(" ")[1],
        social_type: "facebook",
      };
      this.setState({ isLoading: true });
      let apiRequest = new ApiRequest("post", "/user/login");
      apiRequest.send(params, (response) => {
        let result = response.data;
        if (result.errors) {
          this.setState({ isLoading: false });
          toast.error(result.message || "Login failed");
        } else {
          localStorage.setItem("gorilla-token", result.token);
          localStorage.setItem("current_user", JSON.stringify(result.user));
          toast.success("Login successful!");
          setTimeout(() => {
            location.href = "/";
          }, 500);
        }
      });
    } else {
      toast.error("Facebook authentication failed");
    }
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <div className="modern-signin-container">
                    <div className="overlay"></div>

          <div className="signin-content">
            {/* Left Panel - Intro Text */}
            <div className="signin-intro-panel">
              <div className="intro-content">
                <h1 className="intro-title">Welcome Back</h1>
                <p className="intro-subtitle">Continue Your Creative Journey</p>
                <p className="intro-text">
                  FilmFuse is the ultimate platform for filmmakers, screenwriters, producers, and creative professionals. Connect with the industry, access job opportunities, monetized distribution, and powerful production management tools.
                </p>
                <div className="intro-features">
                  <div className="feature-item">
                    <span className="feature-icon">🎯</span>
                    <span className="feature-text">Advanced Search & Job Board</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-icon">🎬</span>
                    <span className="feature-text">Film Market & Distribution</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-icon">📊</span>
                    <span className="feature-text">Production Analytics</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-icon">🤝</span>
                    <span className="feature-text">Global Community Network</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Panel - Form */}
            <div className="signin-form-panel">
              <div className="form-wrapper">
                <div className="form-header">
                  <img
                    src="/images/filmfuse-logo.png"
                    className="signin-logo"
                    alt="FilmFuse"
                  />
                  <h2 className="form-title">Sign In</h2>
                  <p className="form-subtitle">Access your FilmFuse account</p>
                </div>

                <form className="modern-signin-form">
                  <div className="form-errors" ref={this.errorsPanel}></div>

                  {/* Email Field */}
                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      placeholder="you@example.com"
                      required
                      ref={this.email}
                      className="form-input"
                    />
                  </div>

                  {/* Password Field */}
                  <div className="form-group">
                    <label htmlFor="password">Password *</label>
                    <input
                      type="password"
                      id="password"
                      placeholder="Enter your password"
                      required
                      ref={this.password}
                      onKeyUp={this.handleKeyUp.bind(this)}
                      className="form-input"
                    />
                  </div>

                  {/* Forgot Password Link */}
                  <div className="form-forgot-password">
                    <a href="/reset">Forgot your password?</a>
                  </div>

                  {/* Google reCAPTCHA */}
                  <div className="form-group recaptcha-group">
                    <Recaptcha
                      ref={this.recaptcha}
                      onChange={this.handleRecaptchaChange}
                    />
                  </div>

                  {/* Submit Button */}
                  <button
                    className="signin-submit-btn"
                    onClick={this.handleLoginClick.bind(this)}
                    type="button"
                    disabled={this.state.isLoading || !this.state.recaptchaToken}
                  >
                    {this.state.isLoading ? (
                      <>
                        <span className="loading-spinner"></span>
                        Signing In...
                      </>
                    ) : (
                      "Sign In"
                    )}
                  </button>

                  {/* Divider */}
                  {/* <div className="form-divider">
                    <span>or continue with</span>
                  </div> */}

                  {/* Social Login */}
                  <div className="social-login-buttons">
                    {/* <GoogleLogin
                      clientId="82784276186-9nrc2ikdgtgha8ee05rqehg7pq1bhjnq.apps.googleusercontent.com"
                      buttonText="Sign in with Google"
                      onSuccess={this.responseGoogle}
                      onFailure={this.responseGoogle}
                      cookiePolicy={"single_host_origin"}
                    /> */}
                  </div>

                  {/* Footer Links */}
                  <div className="form-footer">
                    <p className="signup-link">
                      Don't have an account? <a href="/signup">Create Account</a>
                    </p>
                    <div className="legal-links">
                      <a href="/terms-conditions">Terms & Conditions</a>
                      <span className="separator">•</span>
                      <a href="/privacy">Privacy Policy</a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  componentDidUpdate() {
    if (this.state.errors && this.state.errors.length > 0) {
      this.errorsPanel.current.innerHTML = this.state.errors.join(", ");
    }
  }

  handleKeyUp(e) {
    if (e.keyCode == 13) {
      this.handleLoginClick();
    }
  }

  handleLoginClick() {
    // Clear previous errors
    this.setState({ errors: [] });

    // Validation
    if (!this.email.current.value || this.email.current.value.trim().length === 0) {
      toast.error("Please enter your email address");
      return;
    }

    if (!this.password.current.value || this.password.current.value.length === 0) {
      toast.error("Please enter your password");
      return;
    }

    if (!this.state.recaptchaToken) {
      toast.error("Please verify that you are not a robot");
      return;
    }

    this.setState({ isLoading: true });

    let params = {
      email: this.email.current.value,
      password: this.password.current.value,
      recaptcha_token: this.state.recaptchaToken,
    };
    let apiRequest = new ApiRequest("post", "/user/login");
    apiRequest.send(params, (response) => {
      let result = response.data;
      if (response.errors || result.errors) {
        this.setState({ isLoading: false });
        this.resetRecaptcha();
        toast.error(result.message || "Login failed. Please check your credentials.");
      } else {
        localStorage.setItem("gorilla-token", result.token);
        localStorage.setItem("current_user", JSON.stringify(result.user));
        toast.success("Login successful! Redirecting...");
        setTimeout(() => {
          location.href = "/";
        }, 500);
      }
    });
  }
}

export default Login;
